import { Component, Input, OnInit, ChangeDetectionStrategy, inject, output } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { Icons } from '../../../util/Icons';
import { SessionService } from '../../../services/session.service';
import { LayoutService } from '../../../../@vex/services/layout.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { DefaultClassDirective } from '@ngbracket/ngx-layout/extended';
import { AraEditorComponent } from '../../util/ara-editor/ara-editor.component';

@Component({
	selector: 'uvi-footer',
	templateUrl: './uvi-footer.component.html',
	styleUrls: ['./uvi-footer.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, ReactiveFormsModule, FormsModule, MatFormField, NgClass, DefaultClassDirective, MatLabel, MatInput, AraEditorComponent],
})
export class UviFooterComponent implements OnInit {
	translocoService = inject(TranslocoService);
	sessionService = inject(SessionService);
	private layoutService = inject(LayoutService);
	icons = inject(Icons);

	public selectedLang: string;
	readonly footerFormValid = output<{
		isValid: boolean;
	}>();
	readonly footerTitleChange = output<string>();
	readonly footerTextChange = output<string>();
	isMobile = false;
	private currentFooterTitle: string;
	private currentFooterText: string;

	constructor() {
		const layoutService = this.layoutService;

		this.isMobile = layoutService.isMobile();
	}

	get footerTitle(): string {
		return this.currentFooterTitle;
	}

	@Input() set footerTitle(newText: string) {
		this.currentFooterTitle = newText;
		this.footerTitleChange.emit(newText);
	}

	get footerText(): string {
		return this.currentFooterText;
	}

	@Input() set footerText(newText: string) {
		this.currentFooterText = newText;
		this.footerTextChange.emit(newText);
	}

	ngOnInit(): void {
		switch (this.translocoService.getActiveLang()) {
			case 'de':
				this.selectedLang = 'german';
				break;
			case 'en':
				this.selectedLang = 'english';
				break;
		}
	}
}
